import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export const BookingSuccess = () => {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (!sid) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/bookings/status/${sid}`);
        setStatus(data);
        if (data.payment_status !== "paid" && tries < 10) { tries += 1; setTimeout(poll, 2000); }
      } catch { setStatus({ error: true }); }
    };
    poll();
  }, [sid]);
  return (
    <div className="container-kore py-32 max-w-xl text-center">
      <CheckCircle2 size={54} className="text-kore-gold mx-auto" />
      <h1 className="display-2 mt-8 text-kore-forest">You're booked in.</h1>
      <p className="mt-4 text-kore-ink/70">{status?.class_name ? `We've saved your spot for ${status.class_name}.` : "Confirmation is on its way to your inbox."}</p>
      <p className="mt-2 text-xs text-kore-gold uppercase tracking-[0.22em]">Payment status: {status?.payment_status || "verifying…"}</p>
      <Link to="/classes" className="btn-primary mt-10">Explore more classes</Link>
    </div>
  );
};

export const BookingCancel = () => (
  <div className="container-kore py-32 max-w-xl text-center">
    <XCircle size={54} className="text-kore-ink/40 mx-auto" />
    <h1 className="display-2 mt-8 text-kore-forest">Booking cancelled.</h1>
    <p className="mt-4 text-kore-ink/70">No charge was made. Ready to try again?</p>
    <Link to="/classes" className="btn-primary mt-10">Back to classes</Link>
  </div>
);

export const NotFound = () => (
  <div className="container-kore py-40 text-center">
    <div className="font-display text-[8rem] leading-none text-kore-gold">404</div>
    <h1 className="display-2 mt-4 text-kore-forest">Page not found.</h1>
    <p className="mt-3 text-kore-ink/60">The trail ended here. Let's get you back on route.</p>
    <Link to="/" className="btn-primary mt-10">Home</Link>
  </div>
);
